import { connect } from 'react-redux'
// For Lifecycle composing
import { compose, lifecycle } from 'recompose'
import Link from '../../components/link/linkComponent'
import { State } from '../../redux/reducers/'
import { selectLegalDoc } from '../../redux/reducers/ui/uiReducer'
import { actionCreators as sagaActions } from '../../redux/sagas/'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    link: selectLegalDoc(state.ui.legalDocs, 'PRIVACY_POLICY')
  }
}
// In Object form, each funciton is automatically wrapped in a dispatch
export const propsMapping: Callbacks = {
  getLegalDocs: sagaActions.legalDocsActionCreators.fetchLegalDocs
}

export default compose(
  connect(mapStateToProps, propsMapping),
  lifecycle({
    componentDidMount: function () {
      if (this.props.getLegalDocs) {
        this.props.getLegalDocs()
      }
    }
  })
)(Link)



// WEBPACK FOOTER //
// ./src/containers/privacyLink/privacyLinkContainer.js